// Shared, stable framer-motion props (module constants avoid new objects on every render).
export const TAP = { scale: 0.95 };
export const TAP_SOFT = { scale: 0.96 };

export const SHEET_FADE = { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } };
export const SHEET_SLIDE = {
  initial: { y: "100%" },
  animate: { y: 0 },
  exit: { y: "100%" },
  transition: { type: "spring", stiffness: 380, damping: 34 },
};

export const REVEAL_POP = {
  initial: { scale: 1.04 },
  animate: { scale: 1 },
  transition: { type: "spring", stiffness: 300, damping: 14 },
};

export const RESULT_ENTER = { initial: { opacity: 0, y: 16 }, animate: { opacity: 1, y: 0 } };

export const SLOT_POP_FROM = { scale: 0.86 };
export const SLOT_SETTLE = { animate: { scale: 1 }, transition: { type: "spring", stiffness: 420, damping: 16 } };

export const CARD_ENTER = { initial: { opacity: 0, y: 12 }, animate: { opacity: 1, y: 0 } };
const staggerCache = [];
export const cardStagger = (i) => (staggerCache[i] ||= { delay: 0.04 * i, duration: 0.25 });

export const JOURNEY_STEP = { initial: { opacity: 0, x: -14 }, animate: { opacity: 1, x: 0 }, transition: { duration: 0.16 } };

export const CHALLENGE_POP = {
  initial: { scale: 0.8, opacity: 0 },
  animate: { scale: 1, opacity: 1 },
  transition: { type: "spring", stiffness: 320, damping: 18, delay: 0.2 },
};

export const RECORD_POP = {
  initial: { scale: 0.6, rotate: -6, opacity: 0 },
  animate: { scale: [0.6, 1.12, 1], rotate: [-6, 3, 0], opacity: 1 },
  transition: { duration: 0.7, delay: 0.4 },
};

export const REEL_INITIAL_BLUR = { y: "-110%", opacity: 0.4, filter: "blur(2px)" };
export const REEL_INITIAL_SHARP = { y: "-110%", opacity: 0.4, filter: "blur(0px)" };
export const REEL_ANIMATE = { y: "0%", opacity: 1, filter: "blur(0px)" };
export const REEL_EXIT = { y: "110%", opacity: 0 };
